import React, { Component } from "react";
import * as Scroll from "react-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { isInteractiveKeyCode } from "../../utils/helpers";

let scroll = Scroll.animateScroll;

class LoadMore extends Component {
  constructor(props) {
    super(props);
  }
  
  handleLoadMoreKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      this.props.showMore(12);
      this.props.resetGridCalc();
    }
  }

  handleScrollKeyUp(e) {
    if(isInteractiveKeyCode(e)) {
      this.scrollToTop;
    }
  }

  scrollToTop() {
    scroll.scrollToTop();
  }

  renderLoadMoreButton(props) {
    if (props.showLoadMore) {
      return (
        <button 
          id="loadmore" 
          className="load-more-btn btn btn-secondary" 
          data-gtm="true" 
          data-btn-region="sponsorship-grid" 
          onClick={(e) => {props.showMore(12);}}
          onKeyUp={(e) => this.handleLoadMoreKeyUp(e)}
        >
          {this.props.title} <FontAwesomeIcon icon={faAngleDown} />
        </button>
      );
    } else {
      return false;
    }
  }

  render() {
    return (
      <div className={`load-more show-load-more-${this.props.showLoadMore}`}>
        <div className="container">
          {this.renderLoadMoreButton(this.props)}
          <button 
            className="scroll-to-top" 
            onClick={this.scrollToTop}
            onKeyUp={(e) => this.handleScrollKeyUp(e)}
          >
            <FontAwesomeIcon icon={faArrowUp} className="hidden-xs"/>
            <span className="visible-xs-block">Back to top</span>
          </button>
        </div>
      </div>
    );
  }
}

export default LoadMore;
